module.exports = __webpack_public_path__ + "dbcba228.svg";